import i18n from "../../../../constants/i18n";
import { AUDITOR_WORKLOAD_DATA_HEADERS } from "../../../../constants/table-custom-headers/Auditor";
import getWorkloadStore from "../../../../stores/auditor-store/workload-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const WorkloadDataTable = withLiteObserverAndTheme(() => {
  const { workloadDataArray } = getWorkloadStore().getWorkloadArraysData();

  return (
    <Et3Table
      columns={AUDITOR_WORKLOAD_DATA_HEADERS}
      rows={workloadDataArray}
      title={i18n.get("WORKLOAD_TABLE")}
      shouldBeFlagged={false}
      titleKey={"WORKLOAD_TABLE"}
    />
  );
});

export default WorkloadDataTable;
